/* eslint-disable @typescript-eslint/prefer-enum-initializers */
/* eslint-disable @typescript-eslint/naming-convention */
const enum EndianType {
  LittleEndian,
  BigEndian
}
export default EndianType;
